import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Divider,
  Header,
  Icon,
  Modal,
  TextArea,
} from "semantic-ui-react";
import DatetimePicker from "../shared/datetimePicker";
import moment from "moment-timezone";
import _ from "lodash";
import pollsCss from "../../assets/styles/polls/polls.module.scss";
import TimezonePicker from "../shared/timezonePicker";

export const PollsSetting = ({ draft, setDraft, handleDraftChange }) => {
  const [open, setOpen] = useState(false);

  const hasPollEndDate = () => (
    <div className={pollsCss.hasEndDate}>
      <Header as="h4" className={pollsCss.lableHeading}>
        Poll End Date
      </Header>
      <Checkbox
        toggle
        onChange={() =>
          handleDraftChange(
            "data.template_data.hasEndDate",
            !draft.data.template_data.hasEndDate
          )
        }
        checked={draft.data.template_data.hasEndDate}
      />
    </div>
  );

  const endDatePoll = () => {
    return (
      <div className="field">
        <TimezonePicker
          timezone={draft.data.template_data.timeZone}
          handleChange={(event, data) => {
            handleDraftChange("data.template_data.timeZone", data.value);
          }}
        />
        <Header as="h4" className={pollsCss.labels}>
          Deadline
        </Header>
        <DatetimePicker
          dateTime={moment(draft.data.ends_at).tz(draft.data.ends_at)}
          maxDays={365 * 99}
          handleChange={(value) => {
            handleDraftChange("data.ends_at", moment(value).toISOString());
          }}
        />
        <Checkbox
          label="Adapt to User Time Zone"
          // checked={this.state.draft.inferTimezone}
          onChange={() => {}}
          className={pollsCss.adaptTimezone}
        />
      </div>
    );
  };

  const uniqueUserCode = () => (
    <div>
      <Header as="h4" className={pollsCss.lableHeading}>
        Poll Response Tracking
      </Header>
      <p className={pollsCss?.infoText}>
        Track which email recipients clicked on specific poll options
      </p>
      <Checkbox
        toggle
        label={"Enable unique IDs tracking "}
        onChange={() =>
          handleDraftChange(
            "data.template_data.uniqueUserCode",
            !draft.data.template_data.uniqueUserCode
          )
        }
        checked={draft.data.template_data.uniqueUserCode}
      />

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        trigger={
          <Header
            as="h5"
            style={{
              color: "#4E84A1",
              cursor: "pointer",
              marginTop: "10px",
              marginBottom: "30px",
            }}
          >
            How to use this?
          </Header>
        }
        size="small"
        closeIcon
      >
        <Header
          textAlign="center"
          content="How to use Polls Response Tracking"
        />
        <Modal.Content>
          <p className={pollsCss.instruction_modal}>
            <strong>Step 1.</strong>
            <br />
            <span> After the poll is ready, copy the code.</span>
          </p>
          <p className={pollsCss.instruction_modal}>
            <strong>Step 2.</strong>
            <br />
            <span>
              Open your email platform and paste the code into your email body.
            </span>
          </p>
          <p className={pollsCss.instruction_modal}>
            <strong>Step 3.</strong>
            <br />
            <strong>
              <b>Replace</b> <code>{"{{UID}}"}</code>
              <b>
                with the appropriate dynamic variable from your email platform
              </b>
            </strong>
            <br />
            <span>
              For example, if your email marketing software’s unique ID variable
              is
            </span>
            <code>*|UNIQID|*</code>, <span>replace</span>{" "}
            <code>{"{{UID}}"}</code> <span>with it in the embed code.</span>
          </p>
        </Modal.Content>
        <div className={pollsCss.instruction_modal_footer}>
          <Modal.Actions className={pollsCss.action_border}>
            <p>
              <Icon name="mail" /> In case you experience any difficulties, feel
              free to send us a message at{" "}
              <a href="mailto:support@sendtric.com">support@sendtric.com</a>.
            </p>
          </Modal.Actions>
        </div>
      </Modal>
    </div>
  );

  const showResultOnThankYouPage = () => (
    <div style={{ marginTop: "15px" }}>
      <Checkbox
        toggle
        label={"Show Result On Thank You Page"}
        onChange={() =>
          handleDraftChange(
            "data.template_data.resultOnThankYouPage",
            !draft.data.template_data.resultOnThankYouPage
          )
        }
        checked={draft.data.template_data.resultOnThankYouPage}
      />
    </div>
  );

  const closedText = () => {
    return (
      <div>
        <Header as="h4" className={pollsCss.lableHeading}>
          Closed Poll Message
        </Header>
        <p className={pollsCss?.infoText}>
          This message will be shown if customer opens the poll after the
          deadline.
        </p>
        <TextArea
          name={draft?.data?.template_data?.closingText}
          placeholder="Write your text here"
          onChange={(e) => {
            handleDraftChange(
              "data.template_data.closingText",
              e?.target?.value
            );
          }}
          defaultValue={draft?.data?.template_data?.closingText}
          rows={5}
        />
      </div>
    );
  };

  // console.log(draft);

  const pollsDeadline = () => {
    return (
      <div className={pollsCss.deadline}>
        {hasPollEndDate()}
        {draft.data.template_data.hasEndDate && endDatePoll()}
        {draft.data.template_data.hasEndDate && closedText()}
        <Divider style={{ margin: "0 0 30px 0" }} />
      </div>
    );
  };

  return (
    <div>
      {pollsDeadline()}
      {uniqueUserCode()}
      {showResultOnThankYouPage()}
    </div>
  );
};
